import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Table from '../../сomponents/Table';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import {
  getMaterialsList,
  getMaterialsListByVendor,
  deleteMaterial,
} from '../../api/materials';
import Preloader from '../../common/Preloader';
import hasAccess from "../../helpers/permissionChecker";
import * as actions from '../../actions/materials';

export class Materials extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.addMaterial = this.addMaterial.bind(this);
    this.importMaterials = this.importMaterials.bind(this);
    this.getMaterials = this.getMaterials.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      currentPage: 0,
    };

    this.columns = [
      'sku',
      'name',
      'cost',
      'price',
      'vendor',
      'unit_of_measure',
      'notes',
    ];

    this.columnNames = [
      'SKU',
      'Name',
      'Cost',
      'Price',
      'Vendor',
      'U/M',
      'Notes',
    ];
  }

  addMaterial() {
    this.props.moveToAdd();
  }

  importMaterials() {
    this.props.moveToImport();
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  getVendorId() {
    let vendor = null;
    const query = path(['router', 'location', 'search'], this.props);

    if (query.match("^\\?vendor=")) {
      const vendorId = Number(query.substring(8));
      if (Number.isInteger(vendorId)) vendor = vendorId;
    }

    return vendor;
  }

  componentDidMount() {
    const vendor = this.getVendorId();
    this.props.loadList(vendor);
  }

  componentDidUpdate(prevProps) {
    const prevLocation = path(['router', 'location', 'key'], prevProps);
    const currentLocation = path(['router', 'location', 'key'], this.props);
    if (prevLocation !== currentLocation) {
      const vendor = this.getVendorId();
      this.props.loadList(vendor);
    }
  }

  componentWillUnmount() {
    this.props.clearList();
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteMaterial,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteMaterial',
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  getMaterials() {
    const materialsList = path(['materials', 'list'], this.props);

    if (!materialsList) {
      return null;
    }

    const itemActions = {
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        permission: { 'permAreaKey': 'materials_inventory', 'permTypeKey': 'edit' },
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        authorColumnName: 'user_id',
        permission: { 'permAreaKey': 'materials_inventory', 'permTypeKey': 'delete' },
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'delete',
      }
    };

    return (
      <Table
        items={materialsList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        actions={itemActions}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />
    );
  }

  render() {
    const materials = this.getMaterials();
    let preloader = null;

    if (materials === null) {
      preloader = (
        <Preloader
          show={true}
          type={'circle'}
        />
      );
    }

    const vendor = this.getVendorId();
    const vendorName = path(['materials', 'vendor'], this.props);
    const breadcrumbs = vendor ? [
      { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
      { url: `/pages/vendor/${vendor}`, icon: 'person_pin', name: vendorName || 'Vendors' },
      { icon: 'shopping_cart', name: 'Materials' },
    ] : [
      { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
      { icon: 'shopping_cart', name: 'Materials' },
    ];

    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={breadcrumbs} />
        <div className="card rounded">
          <div className="card-header rounded-top">
            Materials
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'materials_inventory', 'permTypeKey': 'create' }) &&
              <div className="d-flex justify-content-between mb-3">
                <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.importMaterials}>
                  <i className="material-icons">add_circle_outline</i>
                  <span className="color-default">Import from XLS</span>
                </button>
                <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addMaterial}>
                  <i className="material-icons">add_circle_outline</i>
                  <span className="color-default">Add</span>
                </button>
              </div>
            }
            {preloader}
            {materials}
            <ConfirmAction id={'deleteMaterial'} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadList: (id) => {
      if (id) {
        getMaterialsListByVendor(id)(dispatch);
      } else {
        getMaterialsList()(dispatch);
      }
    },
    clearList: () => {
      dispatch(actions.getMaterialsList({ list: [], vendor: null }));
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/material/' + id));
    },
    moveToAdd: () => {
      dispatch(push('/pages/material'));
    },
    moveToImport: () => {
      dispatch(push('/pages/materials/import'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Materials);



// WEBPACK FOOTER //
// ./src/containers/Materials/index.js